<div *ngIf="field?.invalid && (showWithoutDirty ? true : field.dirty || field.touched)" class="alert alert-danger">
    <ng-container *ngFor="let error of errorList.toArray()">
        <div *ngIf="field?.errors?.[error.type]">
            {{ error.textInput || field.errors[error.type] }}
        </div>
    </ng-container>
</div>
